module.exports = __webpack_public_path__ + "img/right-rotate-icon.611b6c9d.svg";